/************
 Swipers
 ************/

// swipers keyed by product id
const gallerySwipers = {};

// initialize a swiper set for each gallery wrapper
document.querySelectorAll('.productV30Galleries').forEach(function (wrapper) {
    const productId = wrapper.dataset.productId;

    // thumbnails mobile
    const thumbsSwiper = new Swiper(wrapper.querySelector('.productV30GalleriesThumbnailsSwiper'), {
        slidesPerView: "auto",
        spaceBetween: 5,
        breakpoints: {
            800: {
                slidesPerView: 6,
            }
        },
        loop: true,
        navigation: {
            nextEl: wrapper.querySelector('.productV30GalleriesThumbnailsNext'),
            prevEl: wrapper.querySelector('.productV30GalleriesThumbnailsPrev'),
        },
    });

    // main swiper
    const mainSwiper = new Swiper(wrapper.querySelector('.productV30GalleriesSwiper'), {
        navigation: {
            nextEl: wrapper.querySelector('.productV30SwiperNext'),
            prevEl: wrapper.querySelector('.productV30SwiperPrev'),
        },
        loop: true,
        thumbs: {
            swiper: thumbsSwiper,
        },
    });

    gallerySwipers[productId] = mainSwiper;

    // gallery desktop click — slide main swiper to matching index
    wrapper.querySelectorAll('.productV30GalleryItem').forEach(function (item, index) {
        item.addEventListener('click', function () {
            mainSwiper.slideTo(index);
        });
    });
});

/********************
 Video Popup
 *******************/

// open video
document.querySelectorAll('.productV30Video')?.forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        const popup = document.querySelector(".videoPopup");
        popup.showModal();

        // check if we're on mobile and if .videoPopupVideo.mobileOnly exists
        if (window.innerWidth < 800 && popup.querySelector(".videoPopupVideo.mobileOnly")) {
            popup.querySelector(".videoPopupVideo.mobileOnly").play();
        } else {
            popup.querySelector("video").play();
        }
    })
})


/*****************
 Reviews
 ****************/

document.querySelector("#productV30Review")?.addEventListener("click", function () {
    window.scrollTo({
        top: document.querySelector("#looxReviews").offsetTop - 100,
        behavior: "smooth"
    });
})


/**************
 Function To Update Pricing
 ***************/

// update active variant and show the correct gallery
function updateProductV16(skipImage = false) {

    // if custom product input is checked, we use a different product
    product = defaultProduct;
    if (document.querySelector('.productV30OptionLabelInput:checked').value === "custom") {
        product = customProduct;
    }

    // check for an active color swatch
    if (document.querySelector('.productV30FormGroupFlexColor')) {
        activeVariant = product.variants.filter((variant) => {
            return variant.title === document.querySelector(".productV30FormGroupFlexColor:checked").value;
        })[0]
    } else {
        activeVariant = product.variants[0]
    }


    // switch gallery to the one matching the active product
    document.querySelectorAll('.productV30Galleries').forEach(function (wrapper) {
        wrapper.classList.toggle('active', wrapper.dataset.productId === String(product.id));
    });


    if (!skipImage) {
        // slide to the variant's featured image if it exists
        if (activeVariant && activeVariant.featured_image) {
            const activeWrapper = document.querySelector(`.productV30Galleries[data-product-id="${product.id}"]`);
            const variantImage = activeWrapper?.querySelector(`.productV30SwiperSlide[id="${activeVariant.featured_image.id}"]`);
            if (variantImage) {
                gallerySwipers[product.id]?.slideTo(getElIndex(variantImage));
            }
        }
    }

    // show the default or other dropdown content based on the checked group input
    const isDefaultGroup = document.querySelector('.productV30OptionLabelInput:checked').classList.contains('default');
    const targetClass = isDefaultGroup ? 'custom' : 'default';
    document.querySelectorAll('.productV30DropdownContentTxt').forEach(function (element) {
        element.classList.remove('active');
        if (element.classList.contains(targetClass)) {
            element.classList.add('active');
        }
    })


    // is the variant available?
    let isAvailable = activeVariant?.available;

    // check if the variant is in stock
    if (isAvailable) {
        document.querySelector("#productV30ATC").classList.remove("oos");
        document.querySelector("#productV30ATC").textContent = `Add To Cart`;
    } else {
        document.querySelector("#productV30ATC").classList.add("oos");
        document.querySelector("#productV30ATC").textContent = "Sold Out — Notify Me When Available";
    }


}

updateProductV16(true)

/*******************
 Product Form (Default and Group)
 ********************/

// color swatch support on change
document.querySelectorAll(".productV30FormGroupFlexColor")?.forEach(function (element) {
    element.addEventListener("change", function () {
        // update label
        this.parentElement.parentElement.parentElement.querySelector(".productV30FormGroupHeaderLabel").innerHTML = this.getAttribute("aria-label");

        // update price
        updateProductV16();
    });
});

document.querySelectorAll('.productV30OptionLabelInput').forEach(function (element) {
    element.addEventListener("change", function () {
        updateProductV16();
    })
})


// variant dropdown support on change
document.querySelector("#productV30FormVariants")?.addEventListener("change", updateProductV16);


/****************
 *  Quantity
 *************/

let quantity = 1;


/**************
 Product ATC
 ***************/

// add to cart button
document.querySelector("#productV30ATC").addEventListener("click", async function (e) {
    e.preventDefault();

    // check for out of stock
    if (this.classList.contains("oos")) {
        // check email
        let {value: email} = await Swal.fire({
            title: product.title,
            text: "Enter your email to be notified when this product is back in stock.",
            input: "email",
            inputPlaceholder: "Email Address",
            confirmButtonText: "Notify Me When Available",
        });

        // confirm email is returned
        if (!email) {
            return;
        }

        // add to waitlist
        let formData = new FormData();
        formData.append("a", await klaviyo.account());
        formData.append("email", email);
        formData.append("g", "");
        formData.append("variant", activeVariant.id);
        formData.append("product", product.id);
        formData.append("platform", "shopify");
        formData.append("subscribe_for_newsletter", false);
        fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
            method: "POST",
            body: formData
        })

        // show success message
        await Swal.fire({
            title: "Success!",
            text: "You will be notified when this product is back in stock.",
            confirmButtonText: "OK",
        });

        return;
    }

    // add loading animation
    this.classList.add("loading");

    // create form data
    let formData = {
        items: []
    };


    // normal product
    formData.items.push({
        quantity: quantity,
        id: activeVariant.id,
    });


    // reverse form data
    formData.items.reverse();

    // check if we should go directly to checkout
    if (this.classList.contains('checkout')) {

        // clear cart
        await clearCart();

        await addProduct(formData)

        window.location.href = '/checkout';

        // klaviyo tracking
        try {
            _learnq.push(['track', 'Added to Cart', item]);
        } catch (error) {
            console.error("Klaviyo tracking not found");
        }

        return;
    }

    // add productV30
    await addProduct(formData);

    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    await openCart();
});


// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // click normal atc
        document.querySelector("#productV30ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart_addon"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // check the addon if not already checked
        if (!document.querySelector("#productV30AddonCheckboxInput").checked) {
            document.querySelector("#productV30AddonCheckbox").click();
        }


        // click normal atc
        document.querySelector("#productV30ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

/**************
 Sticky ATC
 ***************/

const stickyAtcObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
        if (entry.isIntersecting) {
            document.querySelector("#productV30ATC").classList.remove("sticky");
        } else {
            document.querySelector("#productV30ATC").classList.add("sticky");
        }
    });
}, {
    rootMargin: "-100px 0px 0px 0px"
})

stickyAtcObserver.observe(document.querySelector("#productV30Content"));

// event listeners for dropdown items
document.querySelectorAll(`.productV30DropdownTop`).forEach(function (element) {
    element.addEventListener("click", function () {
        this.parentElement.classList.toggle("active");
    });
});

/**************
 Shipping Time
 ***************/

// Consistent random number generation using the hash as a seed
function generateSeededRandom(key, min, max) {
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
        hash = (hash << 5) - hash + key.charCodeAt(i);
        hash |= 0;
    }

    const x = Math.sin(hash) * 10000;
    const seed = x - Math.floor(x);

    return Math.floor(seed * (max - min + 1) + min);
}

let ordersRemaining = localStorage.getItem('ordersRemaining');

// check local storage for orders remaining and set
if (ordersRemaining && localStorage.getItem('productHandle') === product.handle) {
    if (document.querySelector('#productV30ShippingRemainingTxt')) {
        document.querySelector('#productV30ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
    }
} else {
    // generate random number and set local storage if not found
    ordersRemaining = generateSeededRandom(product.handle, 10, 100);
    localStorage.setItem('ordersRemaining', ordersRemaining);
    localStorage.setItem('productHandle', product.handle);

    if (document.querySelector('#productV30ShippingRemainingTxt')) {
        document.querySelector('#productV30ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
    }
}

// show shipping tomorrow
let date = new Date();
date.setDate(date.getDate() + 1);
date = date.toLocaleDateString('en-US', {month: 'short', day: 'numeric'});
document.querySelector('#productV30ShippingDateTxt').innerHTML = `Ships <strong>Tomorrow, ${date}</strong>`;


// check local storage for orders remaining and set
if (ordersRemaining && localStorage.getItem('productHandle') === product.handle) {
    document.querySelector('#productV30ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
} else {
    // generate random number and set local storage if not found
    ordersRemaining = generateSeededRandom(product.handle, 10, 100);
    localStorage.setItem('ordersRemaining', ordersRemaining);
    localStorage.setItem('productHandle', product.handle);
    document.querySelector('#productV30ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
}


// open productV30Popup dialog
document.querySelectorAll('.openVideo')?.forEach(function (element) {
    element.addEventListener('click', function () {
        document.querySelector(".productV30Popup").showModal();
        document.querySelector("body").classList.add("noScroll");

        // play video
        document.querySelector(".productV30PopupVideo")?.play();


    });
})

// close productV30Popup
function closePopup() {
    document.querySelector(".productV30Popup")?.close();
    document.querySelector("body").classList.remove("noScroll");

    // pause video and reset time
    document.querySelector(".productV30PopupVideo")?.pause();

}

// close productV30Popup event listener
document.querySelectorAll(".productV30PopupBodyHeaderClose")?.forEach(function (element) {
    element.addEventListener("click", closePopup);
});

document.querySelector(".productV30Popup")?.addEventListener("click", function (e) {
    if (e.target === this) {
        closePopup();
    }
})

// close event
document.querySelector(".productV30Popup")?.addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});